import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    cloneSuccess: false,
    coursePlanItems: [],
    coursePlanData: {}
  },
  getters: {
    coursePlanItems (state) {
      return state.coursePlanItems
    },
    cloneSuccess (state) {
      return state.cloneSuccess
    },
    coursePlanData (state) {
      return state.coursePlanData
    }
  },
  mutations: {
    setCoursePlanItems (state, payload) {
      state.coursePlanItems = payload
    },
    setCloneSuccess (state, payload) {
      state.cloneSuccess = payload
    },
    setCoursePlanData (state, payload) {
      state.coursePlanData = payload
    }
  },
  actions: {
    fetchCoursePlansBySection ({ commit, dispatch }, payload) {
      console.log('actions fetchCoursePlansBySection')
      Vue.axios.get(`${config.serverURI}/coursePlans/findAllBySection/${payload}`).then((response) => {
        console.log('fetchCoursePlansBySection', response.data)
        commit('setCoursePlanItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    /*cloneCoursePlan({ commit, dispatch }, payload) {
      console.log('cloneCoursePlan payload', payload)
      Vue.axios.get(`${config.serverURI}/coursePlans/cloneCoursePlan?srcSection=${payload.clone}&desSection=${payload.section}`).then((response) => {
        console.log('cloneCoursePlan', response.data)
        commit('setCloneSuccess', true)
        dispatch('fetchCoursePlansBySection', payload.section)
        setTimeout(() => commit('setCloneSuccess', false), 1000)
        dispatch('snackbarOnSuccess', 'คัดลอกแผนการสอนเสร็จสิ้น')
      }).catch((error) => {
        console.log(error)
        commit('setCloneSuccess', false)
        dispatch('snackbarOnLoadFail', error)
      })
    },*/
    initCoursePlanData({ commit, dispatch }, payload) {
      console.log('initCoursePlanData: ', payload)
      commit('setCoursePlanData', payload)
    },
    updateCoursePlanLG({ commit, dispatch }, payload) {
      Vue.axios.put(`${config.serverURI}/coursePlans/`).then((response) => {
        console.log('updateCoursePlanLG', response.data)

        dispatch('snackbarOnSuccess', '')
      }).catch((error) => {
        console.log(error)
        
        dispatch('snackbarOnLoadFail', error)
      })
    },
    updateCoursePlanLNG({ commit, dispatch }, payload) {
      dispatch('loading', true)
      console.log('updateCoursePlanLNG', payload)
      Vue.axios.put(`${config.serverURI}/coursePlans/${payload.id}`, payload).then((response) => {
        console.log('updateCoursePlanLNG', response.data)
        dispatch('snackbarOnSaveSuccess')
        dispatch('fetchCoursePlansBySection', payload.section.id)
        dispatch('loading', false)
      }).catch((error) => {
        console.log(error)
        dispatch('loading', false)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    deleteLecturer({ commit, dispatch, state }, payload) {
      dispatch('loading', true)
      console.log('deleteLecturer', payload)
      Vue.axios.delete(`${config.serverURI}/lecturers/${payload.id}`).then((response) => {
        console.log('deleteLecturer', response.data)
        if(payload.type === 'LNG') state.coursePlanData.combineLecturers.splice(payload.index, 1)
        if(payload.type === 'L') state.coursePlanData.lectureLecturers.splice(payload.index, 1)
        dispatch('snackbarOnDeleteSuccess')
        dispatch('loading', false)
      }).catch((error) => {
        console.log(error)
        dispatch('loading', false)
        dispatch('snackbarOnLoadFail', error)
      })
    },

    loadItemsBySection ({ commit, dispatch }, payload) {
      console.log('actions loadItemsByBySection')
      return Vue.axios.get(`${config.serverURI}/coursePlans/findAllBySection/${payload}`)
    },
    loadItemsBySectionAsPage ({ commit, dispatch }, pagination) {
      console.log('actions loadItemsByBySection')
      return Vue.axios.get(`${config.serverURI}/coursePlans/findAllBySection/${pagination.section}/page`, { params: pagination })
      // return Vue.axios.get(`${config.serverURI}/coursePlans/findAllBySection/${payload}`)
    },
    update({ commit, dispatch }, payload) {
      console.log('update', payload)
      return Vue.axios.put(`${config.serverURI}/coursePlans/${payload.id}`, payload)
    },
    cloneCoursePlan({ commit, dispatch }, payload) {
      console.log('cloneCoursePlan payload', payload)
      return Vue.axios.get(`${config.serverURI}/coursePlans/cloneCoursePlan?srcSection=${payload.target}&desSection=${payload.section}`)
    },
    createCoursePlan(commit, payload) {
      console.log('createCoursePlan payload', payload)
      return Vue.axios.get(`${config.serverURI}/coursePlans/create/${payload}`)
    },
    regenerateCoursePlans ({ commit, dispatch }, payload) {
      console.log('actions regenerateCoursePlans', payload)
      return Vue.axios.get(`${config.serverURI}/coursePlans/regenerate/${payload}`)
    },
    resetCoursePlan ({ commit, dispatch }, payload) {
      console.log('actions resetCoursePlan', payload)
      return Vue.axios.get(`${config.serverURI}/coursePlans/reset/${payload}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/coursePlan.js